import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const FooterContainer = styled.footer`
  background-color: #f5f7f9;
  padding: 20px 0;
  text-align: center;
  border-top: 1px solid #e7e7e7;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 0 20px;
`;

const FooterSection = styled.div`
  margin: 20px;
  min-width: 200px;
  text-align: left;
`;

const FooterTitle = styled.h3`
  color: #14464F;
  margin-bottom: 15px;
  font-size: 18px;
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const FooterLink = styled(Link)`
  color: #666;
  text-decoration: none;
  font-size: 14px;
  &:hover {
    color: #316C6E;
  }
`;

const ExternalLink = styled.a`
  color: #666;
  text-decoration: none;
  font-size: 14px;
  &:hover {
    color: #316C6E;
  }
`;

const Footer = () => {
  const { language } = useLanguage();
  
  const content = {
    en: {
      about: 'About Us',
      contact: 'Contact',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Policy'
    },
    es: {
      about: 'Sobre Nosotros',
      contact: 'Contacto',
      terms: 'Términos y Condiciones',
      privacy: 'Política de Privacidad',
      cookies: 'Política de Cookies'
    }
  };

  const t = content[language];

  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterTitle>QuisqueyaQuest</FooterTitle>
          <FooterLinks>
            <FooterLink to="/about">{t.about}</FooterLink>
            <ExternalLink href="mailto:contact@quisqueyaquest.com">{t.contact}</ExternalLink>
          </FooterLinks>
        </FooterSection>
        <FooterSection>
          <FooterTitle>Legal</FooterTitle>
          <FooterLinks>
            <FooterLink to="/legal/terms">{t.terms}</FooterLink>
            <FooterLink to="/legal/privacy">{t.privacy}</FooterLink>
            <FooterLink to="/legal/cookies">{t.cookies}</FooterLink>
          </FooterLinks>
        </FooterSection>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
